/**
 * Chữ nút xác nhận dùng chung. Chính tả chuẩn: "Hủy", "Xóa" (không "Huỷ"/"Xoá").
 * Chữ riêng theo ngữ cảnh (Trình ký, Thu hồi, Ghi lại...) giữ tại chỗ, không gom vào đây.
 */
export const CONFIRM_TEXT = {
  ok: 'Đồng ý',
  confirm: 'Xác nhận',
  cancel: 'Hủy',
  delete: 'Xóa',
  save: 'Lưu',
} as const

/** Chữ nút xóa; có số lượng khi xóa hàng loạt: `Xóa (3)`. */
export const deleteText = (count?: number): string =>
  count === undefined ? CONFIRM_TEXT.delete : `${CONFIRM_TEXT.delete} (${count})`
